import React from 'react'
import PropTypes from 'prop-types'
import Box from '@mui/material/Box'
import Typography from '@mui/material/Typography'
import EventBusyIcon from '@mui/icons-material/EventBusy'
import { GRADIENT, ICON, ON_ORANGE, RADIUS, TEXT } from '../../theme/tokens'

/** Icon, title and subtitle at the top of each Holidays page, with optional actions on the right. */
const HolidayHeader = ({ title, subtitle, actions = null }) => (
    <Box
        sx={{
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'space-between',
            gap: 2,
            mb: 3,
            flexWrap: 'wrap',
        }}
    >
        <Box sx={{ display: 'flex', alignItems: 'center', gap: 2 }}>
            <Box
                sx={{
                    width: 40,
                    height: 40,
                    borderRadius: `${RADIUS.md}px`,
                    background: GRADIENT.brand,
                    display: 'flex',
                    alignItems: 'center',
                    justifyContent: 'center',
                    flexShrink: 0,
                }}
            >
                <EventBusyIcon sx={{ color: ON_ORANGE, fontSize: ICON.xl }} />
            </Box>
            <Box>
                <Typography
                    component="h1"
                    sx={{
                        typography: 'h2',
                        fontWeight: 700,
                        color: TEXT.primary,
                        lineHeight: 1.2,
                    }}
                >
                    {title}
                </Typography>
                {subtitle && (
                    <Typography
                        sx={{
                            typography: 'caption',
                            color: TEXT.muted,
                            mt: 0.25,
                        }}
                    >
                        {subtitle}
                    </Typography>
                )}
            </Box>
        </Box>
        {actions && <Box sx={{ display: 'flex', gap: 1.5 }}>{actions}</Box>}
    </Box>
)

HolidayHeader.propTypes = {
    title: PropTypes.string.isRequired,
    subtitle: PropTypes.string,
    actions: PropTypes.node,
}

export default HolidayHeader
